;(function ReferenceImagesCarousel() {
    function ReferenceImagesCarousel($dom) {
        /**
         * // local object availability
         * @type {LightboxCarousel}
         * @private
         */
        var _this = this

        /**
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            this.renderSlickCarousel()
        }

        /**
         * @method renderSlickCarousel
         * @returns {undefined}
         */
        this.renderSlickCarousel = function () {
            $dom.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 4000,
                arrows: true,
                dots: true,
            })
        }

        /**
         * initialize call
         */
        _this.init()
    }

    // define the global scope
    if (!window.Creaton) {
        window.Creaton = {}
    }

    window.Creaton.ReferenceImagesCarousel = ReferenceImagesCarousel
})()

$(document).ready(function () {
    var $technicalDrawingsLightboxCarousel = $('[rel="reference-images--lightbox-carousel"]')
    if ($technicalDrawingsLightboxCarousel.length >= 1) {
        new window.Creaton.ReferenceImagesCarousel($technicalDrawingsLightboxCarousel)
    }
})
